import { priceTiers } from "../data/markings";
import type { DesignElement, MarkingTechnique, PriceTier, Product, Quote } from "../types/configurator";

export function getTier(quantity: number): PriceTier {
  let tier = priceTiers[0];
  for (const t of priceTiers) {
    if (quantity >= t.min) tier = t;
  }
  return tier;
}

export function getLowestPrice(product: Product): number {
  return product.basePrice * priceTiers[priceTiers.length - 1].factor;
}

export function zoneColorCount(elements: DesignElement[], marking: MarkingTechnique, logoColors: number): number {
  if (marking.maxColors <= 1) return 1;
  const inks = new Set(elements.flatMap((e) => (e.kind === "image" ? [] : [e.color.toLowerCase()])));
  const hasImage = elements.some((e) => e.kind === "image");
  const total = inks.size + (hasImage ? logoColors : 0);
  return Math.min(marking.maxColors, Math.max(1, total));
}

export function computeQuote(
  product: Product,
  quantity: number,
  marking: MarkingTechnique | null,
  elements: DesignElement[],
  logoColors: number
): Quote {
  const unitProduct = product.basePrice * getTier(quantity).factor;
  let unitMarking = 0;
  let setup = 0;
  const zoneIds = Array.from(new Set(elements.map((e) => e.zoneId)));
  const groups = zoneIds.length ? zoneIds.map((z) => elements.filter((e) => e.zoneId === z)) : [[]];

  if (marking) {
    for (const group of groups) {
      const colorsCount = zoneColorCount(group, marking, logoColors);
      unitMarking += marking.unitBase + marking.unitPerColor * (colorsCount - 1);
      setup += marking.setupPerColor ? marking.setupFee * colorsCount : marking.setupFee;
    }
  }

  const unitTotal = unitProduct + unitMarking;
  return {
    unitProduct,
    unitMarking,
    unitTotal,
    setup,
    total: unitTotal * quantity + setup,
    zoneCount: marking ? groups.length : 0,
  };
}

const euro = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });

export function formatEuro(value: number): string {
  return euro.format(value);
}
